import { getRbacIsAdmin, getRbacPermissions } from '../../auth/sessionRbac'
import { RBAC_ACTIONS } from './rbacActions'

export { RBAC_ACTIONS }
export { getRbacPermissions, getRbacIsAdmin }

export function permissionKey(scope, action) {
  return `${scope}:${action}`
}

export function has(permissionString) {
  if (getRbacIsAdmin()) return true
  return getRbacPermissions().includes(permissionString)
}

export function can(scope, action) {
  return has(permissionKey(scope, action))
}

export function canRead(scope) {
  return can(scope, RBAC_ACTIONS.READ) || can(scope, RBAC_ACTIONS.READ_WRITE)
}

export function canWrite(scope) {
  return can(scope, RBAC_ACTIONS.READ_WRITE)
}

export function canDownload(scope) {
  return can(scope, RBAC_ACTIONS.DOWNLOADS)
}
